var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 916,
    height: 232,
    viewBox: "0 0 916 232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Prancheta_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 916,
    height: 232
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prancheta_3",
    "data-name": "Prancheta \\u2013 3",
    clipPath: "url(#clip-Prancheta_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_final",
    transform: "translate(-33.57 -722.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3159",
    "data-name": "Grupo 3159",
    transform: "translate(300.57 778.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2422",
    "data-name": "Caminho 2422",
    d: "M359.47,1250.185c-6.055,7.157-16.513,11.378-28.073,11.378-14.132,0-30.827-9.543-30.827-29.361,0-20.733,16.7-28.259,30.827-28.259,11.742,0,22.2,3.67,28.073,10.822v-12.3c0-8.992-7.708-14.865-19.45-14.865a37.281,37.281,0,0,0-25.874,10.463l-8.81-15.6c10.822-9.543,24.772-13.945,38.717-13.945,20.168,0,38.717,8.072,38.717,33.577v57.252h-23.3Zm0-23.119c-3.852-5.14-11.2-7.708-18.717-7.708-9.174,0-16.7,4.771-16.7,13.394,0,8.259,7.526,13.03,16.7,13.03,7.521,0,14.865-2.573,18.717-7.708Z",
    transform: "translate(-300.57 -1142.818)",
    fill: "#0A81C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2423",
    "data-name": "Caminho 2423",
    d: "M535.2,1168.54c18.166,0,29.174,7.87,35.048,15.962L555,1198.816c-4.22-6.237-10.645-9.543-18.717-9.543-14.127,0-24.039,10.276-24.039,25.692s9.912,25.869,24.039,25.869a22.377,22.377,0,0,0,18.746-9.538l15.249,14.127c-5.873,8.259-16.882,16.149-35.048,16.149-27.34,0-46.976-19.268-46.976-46.607C488.22,1187.808,507.857,1168.54,535.2,1168.54Z",
    transform: "translate(-395.931 -1142.829)",
    fill: "#0A81C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2424",
    "data-name": "Caminho 2424",
    d: "M707.364,1177.34c14.506,0,23.07,5.765,29.883,14.329l-6.291,5.593c-6.291-8.362-13.8-11.707-23.065-11.707-19.745,0-31.806,15.741-31.806,36s12.061,36.174,31.806,36.174c9.262,0,16.774-3.5,23.065-11.884l6.291,5.608c-6.813,8.736-15.377,14.5-29.883,14.5-24.811,0-41.064-19.745-41.064-44.384S682.552,1177.34,707.364,1177.34Z",
    transform: "translate(-486.398 -1147.3)",
    fill: "#0A81C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2425",
    "data-name": "Caminho 2425",
    d: "M837.53,1179.817h9.085v14.506c7.167-9.439,16.779-16.233,28.486-16.233v9.961a36.489,36.489,0,0,0-4.545-.349c-8.564,0-20.094,7.688-23.941,15.027v61.487H837.53Z",
    transform: "translate(-573.401 -1147.681)",
    fill: "#0A81C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2426",
    "data-name": "Caminho 2426",
    d: "M966.684,1177.34c25.687,0,39.844,20.443,39.844,44.763v2.459h-70.6c.876,18.348,13.109,33.552,32.854,33.552a37.5,37.5,0,0,0,27.787-11.712l4.717,5.942c-8.392,8.741-19.046,13.63-33.031,13.63-24.639,0-42.3-18.348-42.3-44.384C925.975,1197.085,943.265,1177.34,966.684,1177.34Zm-30.758,40.016h61.34c-.177-14.329-9.612-32.15-30.758-32.15C946.585,1185.205,936.624,1202.678,935.926,1217.356Z",
    transform: "translate(-618.327 -1147.3)",
    fill: "#0A81C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2427",
    "data-name": "Caminho 2427",
    d: "M1187.4,1219.357a35.953,35.953,0,0,1-29.356,15.549c-22.367,0-37.748-17.123-37.748-44.212,0-26.735,15.382-44.384,37.748-44.384,11.884,0,22.544,6.114,29.356,15.741V1116.27h9.262v116.58H1187.4Zm0-49.455c-4.919-8.215-15.9-15.377-27.782-15.377-18.692,0-29.514,15.741-29.514,36.169s10.822,36,29.514,36c11.879,0,22.888-6.99,27.782-15.032Z",
    transform: "translate(-717.077 -1116.27)",
    fill: "#0A81C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2428",
    "data-name": "Caminho 2428",
    d: "M1313.92,1131.04a7.127,7.127,0,0,1,6.99-6.99,6.99,6.99,0,1,1,0,13.98A7.123,7.123,0,0,1,1313.92,1131.04Zm2.459,21.319h9.09v84.4h-9.09Z",
    transform: "translate(-815.456 -1120.223)",
    fill: "#0A81C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2429",
    "data-name": "Caminho 2429",
    d: "M1369.82,1225.927V1165.99h-13.98v-8.215h13.98V1134.71h9.262v23.065h17.123v8.215h-17.123v58.536c0,6.813,2.794,11.535,8.736,11.535a13.188,13.188,0,0,0,9.435-4.019l3.5,6.99c-3.32,3.143-7.339,5.239-14.329,5.239C1375.235,1244.275,1369.82,1237.462,1369.82,1225.927Z",
    transform: "translate(-836.756 -1125.64)",
    fill: "#0A81C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2430",
    "data-name": "Caminho 2430",
    d: "M1454.24,1221.552c0-24.639,15.9-44.212,40.542-44.212,24.988,0,40.714,19.573,40.714,44.212s-15.741,44.384-40.714,44.384C1470.143,1265.936,1454.24,1246.191,1454.24,1221.552Zm71.473,0c0-18.692-11.009-36-30.93-36-19.573,0-30.753,17.3-30.753,36,0,18.874,11.181,36.174,30.753,36.174C1514.7,1257.726,1525.713,1240.426,1525.713,1221.552Z",
    transform: "translate(-886.753 -1147.3)",
    fill: "#0A81C4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2431",
    "data-name": "Caminho 2431",
    d: "M890.393,722.62q-1.938,3.384-4.142,6.547c-.079.1-.148.2-.216.3A89.576,89.576,0,1,1,882.6,622.179l-26.4,15.17a59.864,59.864,0,1,0,8.215,70.371l-22.78-12.976a33.665,33.665,0,1,1-.216-33.646l6.572,11.191,71.394-41.014-6.65-11.392a115.818,115.818,0,1,0-26.7,147.727v25.751h26.213V735.178l-10.463-6.011Z",
    transform: "translate(-663.371 160)",
    fill: "#0A81C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.36250db565a9f8f4ee33acd6966d4e3e.svg";
export { ForwardRef as ReactComponent };